import {
  LOG_IN,
  LOG_IN_MESSAGE,
  LOADING,
  LOADED,
  MODE_SCREEN,
  USER_LOGGED_LOADED,
  USER_LOGGED_PREFERENCE,
  SIDEBAR_LEFT,
  SIDEBAR_RIGHT,
  MODAL_OPEN,
  SET_PROFILE_RULES,
  UPDATE_TERMS_OF_USE,
} from './layoutActions';

const logIn = sessionStorage.token;
const user = sessionStorage.userInfo;

const initialState = {
  logIn: !!logIn,
  logInMessage: '',
  load: false,
  modeScreen: 'desktop',
  sidebarRight: false,
  sidebarLeft: false,
  statusModal: '',
  user: user ? JSON.parse(user) : undefined,
  preference: {
    language: {
      id: 'pt-BR',
      name: 'Português',
    },
  },
  lists: {
    language: [
      {
        id: 'pt-BR',
        name: 'Português',
      },
      {
        id: 'en-US',
        name: 'English',
      },
    ],
    modeColor: [
      {
        id: 'claro',
        name: 'Claro',
      },
      {
        id: 'escuro',
        name: 'Escuro',
      },
    ],
  },
  profileRules: {
    hasAccessPrimary: false,
    hasAccessSecondary: false,
    hasAccessTransactions: false,
    hasAccessDataLayers: false,
    hasAccessGeneralMarkets: false,
    dataLayerAccessRules: {
      hasAccessDistricts: false,
      hasAccessZoning: false,
      hasAccessValueZoning: false,
    },
  },
};

export default function layoutReducer(state = initialState, { type, payload }) {
  switch (type) {
    case LOG_IN:
      return { ...state, logIn: payload };
    case LOG_IN_MESSAGE:
      return { ...state, logInMessage: payload };
    case LOADING:
      return { ...state, load: true };
    case LOADED:
      return { ...state, load: false };
    case UPDATE_TERMS_OF_USE:
      return { ...state, terms_of_use: payload };
    case MODE_SCREEN:
      return { ...state, modeScreen: payload };
    case USER_LOGGED_LOADED:
      return { ...state, user: payload };
    case USER_LOGGED_PREFERENCE:
      return {
        ...state,
        preference: {
          ...state.preference,
          [payload.target.name]: payload.target.value,
        },
      };
    case SIDEBAR_LEFT:
      return { ...state, sidebarLeft: payload };
    case SIDEBAR_RIGHT:
      return { ...state, sidebarRight: payload };
    case MODAL_OPEN:
      return { ...state, statusModal: payload };
    case SET_PROFILE_RULES:
      return {
        ...state,
        profileRules: payload,
      };
    default:
      return state;
  }
}
